import React, {useState} from 'react';
import Navigation from "./components/_common/Navigation";
import RouterApp from "./router";
import './assets/scss/app.scss';
import "@fortawesome/fontawesome-free/js/all";
import 'bootstrap/dist/js/bootstrap.min'
import MapContextProvider from "./context/MapContext";
import OffLineBanner from "./components/_common/OfflineBanner";

function App() {
    const [onlineApp, setOnlineApp] = useState(navigator.onLine)

    window.addEventListener('online', () => {
        setOnlineApp(navigator.onLine)
    })

    window.addEventListener('offline', () => {
        setOnlineApp(navigator.onLine)
    })

    return (
        <div className="App" id='app'>
            <MapContextProvider>
                <Navigation/>
                <div id={'container'}>
                    <RouterApp/>
                </div>
                {/*Banner if offline mode*/}
                {!onlineApp && <OffLineBanner/>}
            </MapContextProvider>
        </div>
    );
}

export default App;
